module.exports = __webpack_public_path__ + "static/media/material-symbols-outlined.d75cc3b4.woff2";